module.exports = __webpack_public_path__ + "img/the-virgins-lover.6774e067.png";